import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';
import { TestSessionForRegistrationDto } from 'src/app/core/dtos/dto';
import { BrandEnum } from 'src/app/core/dtos/enum';
import { LoadingService } from 'src/app/core/services/loading.service';
import { RegistrationService } from 'src/app/core/services/registration.service';

@Component({
  selector: 'app-public-sittings',
  templateUrl: './public-sittings.component.html',
  styleUrls: ['./public-sittings.component.scss']
})
export class PublicSittingsComponent implements OnInit, OnDestroy {

  showAlert: boolean;
  webDelivery: boolean;
  cities: string[];
  sessionsByTestCentreSubscription: Subscription;
  sessionsForRegistrationSubscription: Subscription;
  publicSittings: TestSessionForRegistrationDto[];
  sittings: TestSessionForRegistrationDto[];

  @Input() testTypeId: number;
  @Input() testPurposeId: number;
  @Input() brandId: BrandEnum;
  @Output() selectSitting: EventEmitter<TestSessionForRegistrationDto> = new EventEmitter();

  constructor(
    private registrationService: RegistrationService,
    private toastService: HotToastService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.webDelivery = false;
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  getTestSessionsByTestCentre(params: { testPurposeId: number; testTypeId: number; testCentreId: number }) {
    this.sessionsByTestCentreSubscription = this.registrationService.getTestSessionsByTestCentre(this.brandId, params.testPurposeId, params.testTypeId, params.testCentreId)
      .subscribe(
        result => {
          this.loadingService.hide();
          this.publicSittings = result.content;
          this.showAlert = true;
        },
        () => {
          this.loadingService.hide();
          this.toastService.warning("Unable to load public sittings.");
        });
  }

  getTestSessionsForRegistration(params: { testPurposeId: number; testTypeId: number; regionId: number }) {
    this.sessionsForRegistrationSubscription = this.registrationService.getTestSessionsForRegistration(this.brandId, params.testPurposeId, params.testTypeId, params.regionId)
      .subscribe(
        result => {
          this.loadingService.hide();
          this.sittings = result.content;
          this.publicSittings = result.content;
          this.showAlert = true;
          this.cities = Array.from(new Set(this.publicSittings.map(({ testCentreCity }) => testCentreCity)));
        },
        () => {
          this.loadingService.hide();
          this.toastService.warning("Unable to load public sittings.");
        });
  }

  filterSittingsByCity(city: string) {
    this.publicSittings = this.sittings.filter(x => x.testCentreCity === city);
  }

  finalizeSelectedSitting(sitting: TestSessionForRegistrationDto) {
    this.selectSitting.emit(sitting);
  }

  updateSittings(isRegionAvailable: boolean) {
    this.cities = [];
    this.publicSittings = [];
    this.showAlert = false;
    if (isRegionAvailable) {
      this.showAlert = true;
    }
  }

  ngOnDestroy() {
    this.sessionsByTestCentreSubscription?.unsubscribe();
    this.sessionsForRegistrationSubscription?.unsubscribe();
  }
}
